export default __webpack_public_path__ + "static/media/024-laboratory.59a74a62.svg";